var map = {
	"./ADA-icon.svg": "e5b4",
	"./BNB-icon.svg": "afd9",
	"./BTC-icon.svg": "7545",
	"./BUSD-icon.svg": "34cc",
	"./DOT-icon.svg": "c607",
	"./ETH-icon.svg": "a3c8",
	"./FDUSD-icon.svg": "640a",
	"./LVL-icon.svg": "8c63",
	"./SOL-icon.svg": "2dc4",
	"./TUSD-icon.svg": "b12c",
	"./USDC-icon.svg": "8760",
	"./USDT-icon.svg": "c4e1",
	"./XRP-icon.svg": "1214",
	"./lock-icon.svg": "8cb1",
	"./long-icon.svg": "1bca",
	"./resize-tables-icon.svg": "82f5",
	"./short-icon.svg": "f6f8",
	"./warning-icon.svg": "e848"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "85b9";